module.exports = __webpack_public_path__ + "img/3.0133b35f.jpg";